import { render, staticRenderFns } from "./Top_ten_product.vue?vue&type=template&id=1caf22af&scoped=true&"
import script from "./Top_ten_product.vue?vue&type=script&lang=js&"
export * from "./Top_ten_product.vue?vue&type=script&lang=js&"
import style0 from "./Top_ten_product.vue?vue&type=style&index=0&id=1caf22af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf22af",
  null
  
)

export default component.exports